import { replace } from 'connected-react-router';
import { getTeamUrl } from 'Common';

export default () => (dispatch) => {

  dispatch(replace(getTeamUrl(`clients`)));

}
